import React from 'react'
import './index.less'
import { isRtl } from 'src/helper/tool'

let timer = null

export default class extends React.Component {
  state = {
    day: 0,
    hour: 0,
    minute: 0,
    second: 0
  }

  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
  }

  countDown = (times) => {
    if (timer == null && times > 0) {
      timer = setInterval(function () {
        let day = 0
        let hour = 0
        let minute = 0
        let second = 0 // 时间默认值
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - (day * 24)
          minute = Math.floor(times / 60) - (day * 24 * 60) - (hour * 60)
          second = Math.floor(times) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60)
        }
        // if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second

        this.setState({ day: day, hour: hour, minute: minute, second: second })
        times--
      }.bind(this), 1000)
    }
  }

  componentDidMount() {}

  componentWillReceiveProps(e) {
    const { remaintime } = e
    this.countDown(remaintime)
  }

  render() {
    const { day, hour, minute, second } = this.state
    const { language, lang } = this.props

    const div = `
        <div class="item day"><div class="number-wrap">${day}</div>${lang['time_days']}</div>
        <div class="item hour"><div class="number-wrap">${hour}</div>${lang['hours']}</div>
        <div class="item minute"><div class="number-wrap">${minute}</div>${lang['minutes']}</div>
        <div class="item second"><div class="number-wrap">${second}</div>${lang['seconds']}</div>
      `
    return (
      <div className="countdown-wrap">
        <div className={`countdiv ${isRtl(language) ? 'arlang' : ''}`} dangerouslySetInnerHTML={{ __html: div }}>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/countdown/index.js